import React, { useContext } from 'react';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';

import cls from 'classnames';

import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import Mobile from '@/components/Device/Mobile';

import { MyContext } from '@/config/context-manager';

interface ICard {
  icon: string | StaticImport;
  title: string;
  des: string;
  img: string | StaticImport;
  className?: string;
  reverse?: boolean;
  topEmbelish?: string | StaticImport;
}

const Card: React.FC<ICard> = ({ icon, title, img, des, className, reverse, topEmbelish }) => {
  const { locale } = useContext(MyContext);
  return (
    <div
      className={cls(
        'mx-5 mb-5 flex flex-col items-stretch lg:mb-8 xl:mb-10',
        reverse ? 'md:flex-row-reverse' : 'md:flex-row',
      )}
    >
      {/* Mission 卡片 */}
      <div
        className={cls(
          'relative box-border flex w-full flex-col items-start rounded-3xl bg-left-bottom bg-no-repeat p-5 lg:flex-row lg:p-6 xl:h-[241px] xl:rounded-5xl xl:p-10',
          className,
        )}
      >
        {topEmbelish && (
          <Image
            src={topEmbelish}
            alt=""
            width={40}
            height={40}
            className="absolute right-4 top-4 lg:h-12 lg:w-12 xl:h-[62px] xl:w-[62px]"
          />
        )}
        <MaxAndMediumScreen>
          <Image src={icon} alt="" width={100} height={100} className="mr-4 h-[70px] w-[70px] lg:mr-6 xl:mr-10" />
          <div className="flex flex-col justify-center">
            <h2
              className={cls(
                'mb-3 text-[22px] font-black leading-normal text-wk-words-1 lg:text-[28px] xl:mb-4 xl:text-[34px]',
                locale === 'en' && 'leading-[34px]',
                locale === 'zh' && 'font-sourceHanSans',
              )}
            >
              {title}
            </h2>
            <p
              className={cls(
                'text-[14px] font-normal text-wk-words-2 xl:text-[18px] [&>strong]:font-bold [&>strong]:text-wk-words-1',
                locale === 'en'
                  ? ' leading-[20px] -tracking-wide xl:leading-[26px]'
                  : 'leading-[24px] xl:leading-[30px]',
              )}
              dangerouslySetInnerHTML={{ __html: des }}
            />
          </div>
        </MaxAndMediumScreen>
        <Mobile>
          <div className="mb-3 flex flex-row items-center">
            <Image src={icon} alt="" width={100} height={100} className="mr-4 h-10 w-10" />
            <h2
              className={cls('mb-[2px] text-[22px] font-black text-[#1e293b]', locale === 'zh' && 'font-sourceHanSans')}
            >
              {title}
            </h2>
          </div>
          <div className="flex flex-col justify-center text-[14px] font-normal text-wk-words-2 xl:text-[18px] [&>strong]:font-bold [&_strong]:text-wk-words-1">
            <p dangerouslySetInnerHTML={{ __html: des }} />
          </div>
        </Mobile>
      </div>
      <MaxAndMediumScreen>
        <Image
          src={img}
          alt=""
          width={372}
          height={241}
          className={cls(
            'md: h-[174px] w-[250px] rounded-5xl object-cover xl:h-[241px] xl:w-[372px]',
            reverse ? 'mr-8  xl:mr-10' : 'ml-8  xl:ml-10',
          )}
        />
      </MaxAndMediumScreen>
    </div>
  );
};

export default Card;
